export default __webpack_public_path__ + "static/media/banner2.19322e55.png";